import { useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * DynamicFavicon - Simple component that updates page title
 * Favicons are handled by static links in index.html pointing to /api/favicon.ico
 */
const DynamicFavicon = () => {
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/site-settings`)
      .then(res => res.json())
      .then(data => {
        if (data.logo_alt) {
          document.title = data.logo_alt;
        }
      })
      .catch(() => {});
  }, []);

  return null;
};

export default DynamicFavicon;
